import { Component, Input, OnDestroy,PLATFORM_ID,Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { JournalService } from 'src/app/journal/journal.service';
import { AlertService } from 'src/app/services/alert.service';
import { MainBodyService } from 'src/app/services/main-body.service';
import { Alert, AlertType } from 'src/interface/alert';
import { themeData } from 'src/interface/themesetting';

@Component({
	selector: 'app-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnDestroy {
	@Input() id = 0;
	@Input() fade = true;

	alerts: Alert[] = [];
	alertSubscription: Subscription[] = [];
	journalid: string;
	themeSettingsData: themeData;

	constructor(
		@Inject(PLATFORM_ID) private platformId: any,
		private router: ActivatedRoute,
		private alertService: AlertService,
		private journalService: JournalService,
		private mainBodyService: MainBodyService) {
		this.router.params.subscribe(params => {
			this.journalid = params['journal_id'];
		});
		const journalType = { jnl_type: "JNL" }
		if (this.journalid == undefined) {
			this.journalService.getJournals(journalType).subscribe((result) => {
				this.journalid = result.data[0].id;

				if (this.journalid) {
					const themeSub = this.mainBodyService.getAllThemeSettings(this.journalid).subscribe((result) => {
						if (result.data) {
							this.themeSettingsData = result.data;
							const color = this.themeSettingsData.theme_colors;
							Object.entries(color).map(([key, value]) => {
								const element = "--" + key;
								const val = value;
								if (isPlatformBrowser(this.platformId)) {
								document.documentElement.style.setProperty(element, val);
								}
							});
						}
					});
					this.alertSubscription.push(themeSub);
				}
			})
		}
		const alertSub = this.alertService.onAlert()
			.subscribe(alert => {
				this.alerts = [];
				// if (ind == -1) {
				this.alerts.push(alert);
				// }
				if (alert.autoClose) {
					setTimeout(() => this.removeAlert(alert), 2000);
				}
			});
		this.alertSubscription.push(alertSub);
	}

	ngOnDestroy() {
		this.alertSubscription.forEach(x => {
			if (!x.closed) {
				x.unsubscribe();
			}
		});
	}

	removeAlert(alert: Alert) {
		this.alerts = this.alerts.filter(x => x !== alert);
	}

	//Function to get the class for alert.
	alertClass(alert: Alert) {
		if (!alert) return;
		let classes = '';
		const alertTypeClass = {
			[AlertType.Success]: 'alert-success',
			[AlertType.Error]: 'alert-danger',
			[AlertType.Info]: 'alert-primary',
			[AlertType.Warning]: 'alert-warning'
		}
		classes = classes + alertTypeClass[alert.type] + ' ';
		return classes;
	}
}